/**
 * Aurora Theme — Collection filters (brand, price, category) + sorting.
 * Uses Shopify's native filtering (Search & Discovery `collection.filters`)
 * with the section rendering API for AJAX updates, no page reload.
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 450;
  var debounceTimer = null;

  function getCollectionSection() {
    return document.querySelector('[data-collection-section]');
  }

  function buildUrl(extraParams) {
    var section = getCollectionSection();
    var form = document.querySelector('[data-facets-form]');
    var params = new URLSearchParams();

    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
    }

    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);

    if (extraParams) {
      Object.keys(extraParams).forEach(function (key) { params.set(key, extraParams[key]); });
    }

    params.set('section_id', 'main-collection');
    return window.location.pathname + '?' + params.toString();
  }

  function fetchAndRender(url, pushState) {
    var section = getCollectionSection();
    if (!section) return;
    section.setAttribute('aria-busy', 'true');

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection = doc.querySelector('[data-collection-section]');
        if (!newSection) return;

        section.replaceWith(newSection);
        bindAll();

        document.dispatchEvent(new CustomEvent('theme:content-updated', { detail: { root: newSection } }));

        if (pushState) {
          var shareUrl = url.replace(/([?&])section_id=main-collection&?/, '$1').replace(/[?&]$/, '');
          window.history.pushState({}, '', shareUrl);
        }

        newSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function () {})
      .finally(function () {
        if (section.isConnected) section.removeAttribute('aria-busy');
      });
  }

  function onFacetChange() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetchAndRender(buildUrl(), true);
    }, DEBOUNCE_MS);
  }

  function bindFacetsForm() {
    var form = document.querySelector('[data-facets-form]');
    if (!form) return;
    form.querySelectorAll('[data-filter-input]').forEach(function (input) {
      input.addEventListener(input.type === 'number' ? 'input' : 'change', onFacetChange);
    });
  }

  function bindSort() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      fetchAndRender(buildUrl(), true);
    });
  }

  function bindClearAll() {
    var clearBtn = document.querySelector('[data-filters-clear]');
    if (!clearBtn) return;
    clearBtn.addEventListener('click', function () {
      fetchAndRender(window.location.pathname + '?section_id=main-collection', true);
    });
  }

  function bindGroupToggles() {
    document.querySelectorAll('[data-filter-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var group = toggle.closest('[data-filter-group]');
        if (!group) return;
        var collapsed = group.hasAttribute('data-collapsed');
        if (collapsed) {
          group.removeAttribute('data-collapsed');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          group.setAttribute('data-collapsed', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function bindMobileToggle() {
    var toggle = document.querySelector('[data-filters-toggle]');
    var aside = document.querySelector('.collection-filters');
    if (!toggle || !aside) return;

    var backdrop = document.querySelector('.overlay-backdrop') || (function () {
      var el = document.createElement('div');
      el.className = 'overlay-backdrop';
      document.body.appendChild(el);
      return el;
    })();

    toggle.addEventListener('click', function () {
      aside.setAttribute('data-open', '');
      backdrop.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
    });
    backdrop.addEventListener('click', function () {
      aside.removeAttribute('data-open');
      backdrop.removeAttribute('data-open');
      document.body.style.overflow = '';
    });
  }

  function bindAll() {
    bindFacetsForm();
    bindSort();
    bindClearAll();
    bindGroupToggles();
    bindMobileToggle();
  }

  document.addEventListener('DOMContentLoaded', bindAll);
  window.addEventListener('popstate', function () {
    fetchAndRender(window.location.pathname + window.location.search + '&section_id=main-collection', false);
  });
})();